import './functions';
import './logic';
import './reducers';
import { wrapperBuilder } from './build';

export const DeeplinkWrapper = wrapperBuilder.build();
